// extracted by mini-css-extract-plugin
export default {"performanceWrap":"Performance_performanceWrap__4G9D+"};